// -------------------------------------
// Match Height
// -------------------------------------
(function($) {

  $(document).ready(function() {

    // Match Height
    $(".news-block").matchHeight();

  });

})(jQuery);
